
<script>
import appConfig from "@/app.config";
import ReportingApi from "@/services/reporting-api";
import HourlyTurnover from "./HourlyTurnover.vue";
import CountCollectingDataByDaySplineChart from "./countCollectingDataByDaySplineChart.vue";
import DoubleBarChart from "./DoubleBarChart.vue";
import CampaignProgressRate from "./campaignProgressRate.vue";
import GlobalCampaignInfo from "./GlobalCampaignInfo.vue";
import { mapGetters } from 'vuex';
import { frLocale, frRanges } from "@/datePickerConfig.js";


/**
 * Reporting component
 */
export default {
  page: {
    title: "Les Rapports Vente",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {HourlyTurnover, CountCollectingDataByDaySplineChart, DoubleBarChart, CampaignProgressRate, GlobalCampaignInfo},

  
  computed:{
     ...mapGetters('menu', ['menuCampaignId', "menuCampaign"]),
  },

  data(){

    const now = new Date();
    const currentYear = now.getFullYear();

    return{
      range: {
            startDate: new Date(`${currentYear}-01-01`),
            endDate: now,
          },
      frLocale,
      frRanges,
      countCollectingDataByDay:null,
      scanByDay:{
        date:[],
        entryCount:[],
        uniqueScans:[]
      },
      campaignReport: null,
      coverageCollectingRate:null,
      campaignProgressRate:null,
      totalsData:null,
      mostAndLessHourByScan:null,

    }
  },

  watch:{

    menuCampaignId:function(){

      this.showConfigureQRCode = false
      this.initReportingCustomerCompnent()

    },

    range:function(){
      this.initReportingCustomerCompnent()  
    }

    },

  mounted(){
    this.initReportingCustomerCompnent()
    
  },

  methods:{

    initReportingCustomerCompnent(){
      this.getCampaignReport()
      this.getMostAndLessHourByScan()
    },

    clearCampaignReport() {
      this.countCollectingDataByDay = null;
      this.coverageCollectingRate = null;
      this.globalScanRate = null;
      this.totalsData = null;
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },

    // API CALL //


    getMostAndLessHourByScan(){
        if(!this.range || !this.range.startDate || !this.range.endDate){
          return;
        } 
  
        const params = {
          campaignId: this.menuCampaignId,
          start: this.range.startDate,
          end: this.range.endDate
        };
  
        ReportingApi.getMostAndLessHourByScan(params).then((result) => {
          if (result) {
            this.mostAndLessHourByScan = result;
          }
        });
    },

    getCampaignReport() {
      if (!this.range?.startDate || !this.range?.endDate || !this.menuCampaignId) {
        return;
      }

      this.clearCampaignReport();
      this.getCollectingDataPerDay();
      this.getTotalsData();
      this.getScanCoverageRate();
      this.getCoverageRate();

      this.showError = false;
    },

    getParams() {
      return {
        campaignId: this.menuCampaignId,
        start: this.range.startDate,
        end: this.range.endDate,
        page: this.pageChart || 1,
        pageSize: this.pageSize || 10
      };
    },
    
    getCoverageRate() {
      ReportingApi.getCoverageRate(this.getParams())
        .then(res => {
          this.coverageCollectingRate = res || null;
        })
        .catch(() => {
          this.coverageCollectingRate = null;
        });
    },

    getCollectingDataPerDay() {
      ReportingApi.getCollectingDataPerDay(this.getParams())
        .then(res => {
          this.countCollectingDataByDay = res || null;
        })
        .catch(() => {
          this.countCollectingDataByDay = null;
        });
    },

    getTotalsData() {
      ReportingApi.getTotalsData(this.getParams())
        .then(res => {
          this.totalsData = res || null;
        })
        .catch(() => {
          this.totalsData = null;
        });
    },

    getScanCoverageRate() {
      ReportingApi.getScanCoverageRate(this.getParams())
        .then(res => {
          this.globalScanRate = res || null;
        })
        .catch(() => {
          this.globalScanRate = null;
        });
    }
    


  }
}
</script>
<template>
    <div class="home-page-80-width"> 


      <div class="my-4 mx-1">
        <div class="row">
          
          <div class="col-lg-9 col-md-7 col-12 mb-2 mb-md-0">
            <h4 class="global-metric-title">Vue globale (Overview)</h4>
            <div style="font-size: 11px;" v-if="menuCampaign && menuCampaign.customerName">
                Client: <a href="#" class="text-primary">{{ menuCampaign.customerName }}</a> | <a href="#" class="text-primary">{{ menuCampaign.menuName }}</a>
            </div>
          </div>

          <div class="col-lg-3 col-md-5 col-12 text-right">
            <v-dateRangePicker
              ref="picker"
              v-model="range"
              :autoApply="true"
              :locale-data="frLocale"
              opens="left"
              :ranges="frRanges"
            />
          </div>

        </div>
      </div>

      <div v-if="totalsData" class="my-4 mx-1">
        <div class="row align-items-stretch" >

          <div class="col-md-6 col-12 d-flex">
            <CampaignProgressRate
              class="flex-fill pb-md-0 pb-2 mr-md-2 mr-0"
              :coverageCollectingRate="coverageCollectingRate"
              :totalsData="totalsData"
            />
          </div>

          <div v-if="totalsData" class="col-md-6 col-12 d-flex mt-md-0 mt-4">
            <GlobalCampaignInfo
              class="flex-fill p-md-0 p-3 ml-md-2 ml-0"
              :lastEventTimeStamp="totalsData.lastEventTimeStamp"
              :startDate="totalsData.startDate"
              :endDate="totalsData.endDate"
            />
          </div>
        </div>
      </div>


      <div class="row mt-4">
        <b-card class="text-left global-metric-card p-3 mx-1 h-100">
          <div class="text-uppercase text-dark font-weight-bold font-size-14 mb-4">
            Analyse des heures
          </div>

          <div class="row mb-3">
            <!-- Metrics -->
            <div class="col-md-3 col-12 ">
              <div class="mr-md-3 mr-0">

                <div class="p-3 mb-2 bg-light-purple rounded">
                  <div class="text-uppercase font-weight-bold font-size-12 text-purple">Heures de pic</div>
                  <div  v-if="mostAndLessHourByScan && mostAndLessHourByScan.mostAndLestHourScan" class="font-size-16 font-weight-bold text-dark">{{ mostAndLessHourByScan.mostAndLestHourScan.formattedMostScannedHourRange }} <small class="text-meuted" style="font-size: 10px;"> ({{ mostAndLessHourByScan.mostAndLestHourScan.mostScannedCount }} scans) </small> </div>
                  <div class="text-muted font-size-12">Par nombre de scans</div>
                </div>

                <div class="p-3 mb-2 bg-light-green rounded">
                  <div class="text-uppercase font-weight-bold font-size-12 text-green">Heures de pic</div>
                  <div  v-if="mostAndLessHourByScan && mostAndLessHourByScan.mostAndLestHourOrder" class="font-size-16 font-weight-bold text-dark">{{ mostAndLessHourByScan.mostAndLestHourOrder.formattedMostOrderedHourRange }} <small class="text-meuted" style="font-size: 10px;"> ({{ mostAndLessHourByScan.mostAndLestHourOrder.mostOrderedCount }} commandes) </small></div>
                  <div class="text-muted font-size-12">Par nombre de commandes</div>
                </div>

                <div class="p-3 mb-2 bg-light-purple rounded">
                  <div class="text-uppercase font-weight-bold font-size-12 text-purple">Heures creuses</div>
                  <div  v-if="mostAndLessHourByScan && mostAndLessHourByScan.mostAndLestHourScan" class="font-size-16 font-weight-bold text-dark">{{ mostAndLessHourByScan.mostAndLestHourScan.formattedLeastScannedHourRange }} <small class="text-meuted" style="font-size: 10px;"> ({{ mostAndLessHourByScan.mostAndLestHourScan.leastScannedCount }} scans) </small> </div>
                  <div class="text-muted font-size-12">Par nombre de scans</div>
                </div>

                <div class="p-3 mb-2 bg-light-green rounded">
                  <div class="text-uppercase font-weight-bold font-size-12 text-green">Heures creuses</div>
                  <div  v-if="mostAndLessHourByScan && mostAndLessHourByScan.mostAndLestHourOrder" class="font-size-16 font-weight-bold text-dark">{{ mostAndLessHourByScan.mostAndLestHourOrder.formattedLeastOrderedHourRange }} <small class="text-meuted" style="font-size: 10px;"> ({{ mostAndLessHourByScan.mostAndLestHourOrder.leastOrderedCount }} commandes) </small></div>
                  <div class="text-muted font-size-12">Par nombre de commandes</div>
                </div>

              </div>
            </div>

            <div class="col-md-9 col-12">
              <div class="ml-md-3 ml-0 mt-md-0 mt-3 ">
                <HourlyTurnover
                  :campaignId="this.menuCampaignId"  :range.sync="this.range" />
              </div>
            </div>
          </div>
        </b-card>
      </div>

      <div class="row mt-md-4 p-md-0">

        <div v-show="scanByDay" class="col-md-6 col-12 mt-4 mt-lg-0">
          <b-card class="text-left global-metric-card p-3 mx-1 h-100">
              <DoubleBarChart :campaignId="this.menuCampaignId" :range.sync="this.range"></DoubleBarChart>
          </b-card>
        </div>



        <div class="col-md-6 col-12 mt-4 mt-lg-0 pl-lg-2" :key="this.menuCampaignId">
          
          <b-card class="text-left global-metric-card p-3 mx-1 h-100">

            <div class="text-uppercase text-dark font-weight-bold font-size-14 mb-4">
              Utilisation du menu digital
            </div>

            <div class="row mb-4">

              <div class="col-md-6 col-12 mb-3">
                <div class="kpi-card p-3 mr-md-3 mr-0">
                  <div class="text-uppercase text-muted small font-weight-bold">
                    {{ $t('campaign.card.coverageCollectingRate') }}
                  </div>

                  <div class="d-flex align-items-baseline mt-2">
                    <h1 v-if="coverageCollectingRate" class="mb-0 font-weight-bold text-dark">{{ coverageCollectingRate.coverageRateAsString || '0%' }}</h1>
                  </div>
                </div>
              </div>

              <div class="col-md-6 col-12 mb-3">
                <div class="kpi-card p-3 ml-md-3 ml-0">
                  <div class="text-uppercase text-muted small font-weight-bold">
                    Temps moyen / menu
                  </div>

                  <div class="d-flex align-items-baseline mt-2">
                    <h1 v-if="totalsData" class="mb-0 font-weight-bold text-dark">
                      {{ totalsData.averageSpentTime || 0 }}
                    </h1>
                  </div>
                </div>
              </div>

            </div>

            <CountCollectingDataByDaySplineChart
              :campaignId="this.menuCampaignId"
              :countCollectingDataByDay="countCollectingDataByDay == null ? null : countCollectingDataByDay" :range="this.range" />

          </b-card>
        </div>

        <div class="col-2"/>
      </div>



      </div>

</template>

<style>

.period-card{
  background-color: #fff;
  color: #000;
  border-radius: 8px;
  padding: 9px 11px;
  color: #334155;
  font-weight: 500;
  border: 1px solid #ddd;
}

.global-metric-title{
  font-weight: bold;
  font-size: 30px;
  color: #000;
}

.global-metric-card{
  border-radius: 16px;
  border: 1px solid #ddd;
  flex: 1 1 200px;
}

.previewMenuButton{
  background: linear-gradient(135deg, #f4b740, #D4AF37);
  color: #fff;
  letter-spacing: 0.7px;
  line-height: 20px;
  font-weight: bold;
}
/*  */

.toggelsButtons{
  background-color: #F1F5F9;
  border-radius: 20px;
  padding: 0px 10px;
}

.toggels-button {
  font-weight: 600;
  border-radius: 9999px;
  padding: 0.5rem 1.2rem;
  margin: 5px 0px;
  user-select: none;
  transition: background-color 0.3s ease;
}

.toggels-button:hover {
  background-color: #fff;
  color: black;
  cursor: pointer;
}

.toggels-button.active {
  background-color: #fff;
  color: black;
}



.kpi-card {
  background: #f5f7fb;
  border-radius: 12px;
}

.bg-light-purple {
  background-color: #e6e0ff;
}

.bg-light-green {
  background-color: #e6f7e6;
}

.bg-light-red {
  background-color: #ffe6e6;
}

.text-purple {
  color: #5c4dff;
}

.text-green {
  color: #28a745;
}

.text-red {
  color: #ff4d4d;
}

</style>